<style>
pre {
    white-space: pre-wrap;
    word-wrap: break-word;
}
</style>

<template>
    <div class="page">
        <BACK title="鹿路小助手"/>
        <div v-infinite-scroll="handleHelpInfo">
            <el-collapse accordion style="font-family:微軟正黑體;"  @change="handleChange">
                    <el-collapse-item v-for="({title,content,date},i) in getHelpList" :key="i" :name="i">
                    <template slot="title" >
                        <i class="icon el-icon-circle-plus" v-if="openId != i"  style="color: #03AF4D;font-size:1.5rem;margin-left: 5px"></i>
                        <i class="icon el-icon-remove-outline" v-if="openId == i" style="color: #03AF4D;font-size:1.5rem;margin-left: 5px"></i>
                        <span style="font-weight: bolder;padding-left:5px;word-break: break-all;line-height: 24px">{{title}}</span>
                    </template>
                    <pre>{{content}}</pre>
                </el-collapse-item>
            </el-collapse>
        </div>
    </div>
</template>
<script>

import BACK from '@/components/back.vue'
import FN from '@/components/fn'
import {mapActions} from 'vuex'

export default {
    name: 'help',
    components: {
        BACK
    },
    mixins: [FN],
    data() {
        return {
            getHelpList: [],
            openId:-1,
            loading:true
        }
    },
    mounted() {
        this.handleHelpInfo()
    },
    computed: {
        delayTimeText() {
            return this.delayText
        }
    },
    methods: {
        ...mapActions([
            'FETCH'
        ]),
        handleHelpInfo() {
            this.FETCH({
                key: 'GET_HELP_INFO',
                page: this.page
            }).then((res) => {
                this.getHelpList = (res.pagination);
            })
        },
        handleBack() {
            const { href } = this.$router.resolve({name: 'SetList'})
            window.open(href, '_self')
        },
        handleChange(val){
            if(val === ''){
                this.openId = -1;
            }else {
                this.openId = val;
            }
        }
    }
}
</script>
<style>
    .el-collapse-item__header{
        background: #03af4d2b;
    }
    .el-collapse-item__header{
        border-bottom: 1px solid #ffffff;
    }


</style>
